<template>
  <router-link v-if="!isCTA" :to="view.link(doc)" class="articles__item">
    <div class="articles__img-box">
      <div v-if="doc.has_audio" class="articles__play">
        <span class="articles__play-icon iconfont iaudio"></span>
      </div>
      <!-- crossorigin is needed to set request.mode="cors" , without which the
        serviceworker will see an opaque response which is dangerous to cache.
        See: #7397

        Any changes to this attribute should be kept in sync with the book
        card, and also the preload code in `_loadImagesForDocs` in the
        model.
      -->
      <img
        v-lazy="{ src: doc.cover_thumbnail }"
        crossorigin="anonymous"
        class="articles__img"
        alt=""
      />
    </div>
    <div class="articles__text-box">
      <div class="articles__text">
        <h5 class="articles__category card__category">
          {{ view.firstTag(doc) }}
        </h5>
        <h3 class="articles__title card__title">
          {{ doc.title }}
        </h3>
        <h4 class="articles__author card__author">By {{ doc.author }}</h4>
      </div>
      <div class="articles__bottom-box">
        <p class="articles__date">
          {{ subtitle }}
        </p>
        <FavoriteFlag class="articles__collection collection" :doc="doc" />
      </div>
    </div>
  </router-link>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ArticlesView } from '@/models/doc.article'
import { ArticleListItem } from '@/models/interfaces'

import FavoriteFlag from '@/app/components/listing/FavoriteFlag.vue'

const props = defineProps<{
  view: ArticlesView
  doc: ArticleListItem
}>()

const isCTA = computed(() => {
  return props.doc.title === 'CTA'
})

const subtitle = computed(() => {
  const doc = props.doc

  if (doc.original_publish_date) {
    return `${doc.publisher.name} (${doc.original_publish_date.slice(0, 4)})`
  }

  return doc.publisher.name
})
</script>
